// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86f08f71","453":"bb3f220a","455":"cb1061c1"}[chunkId] + ".chunk.js";
};